function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "13",
  viewBox: "0 0 19 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.417 11.47V0H1.583v11.47H0V13h19v-1.53h-1.583zm-6.334 0H7.917v-.764h3.166v.765zm4.75-2.294H3.167V1.53h12.666v7.647z",
  fill: "#12002D"
})));